import React, { useState } from 'react';
import { BiArchiveIn, BiArchiveOut } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../_helpers';
import CustomAlert from '../reusableComponents/CustomAlert';
import { ToolTip } from '../../../_elements/ToolTip';

const ArchiveForms = ({ formId, archived, fetchForms }) => {
    const [showAlert, setShowAlert] = useState(false);
    let message;
    if (archived) {
        message =
            "Archiving the form will hide the form from the users, Users won't be able to submit the form. Do you want to continue?";
    } else {
        message =
            'Unarchiving the form makes it visible to the users again, Users will be able to submit this form. Do you want to continue?';
    }
    const closeAlert = () => {
        setShowAlert(false);
    };
    const archive = async () => {
        try {
            const res = await fetchWrapper.put(`forms/${formId}/archive/${archived}`);
            toast.success('Form is archived Succesfully');
            if (typeof fetchForms === 'function') {
                fetchForms();
            }
            global.log(res);
        } catch (e) {
            global.log(e);
            toast.error(e?.message || 'Failed to perform action');
        }
    };
    return (
        <>
            <div onClick={() => setShowAlert(true)}>
                {archived ? (
                    <ToolTip text={'Archive'} cssStyles={'top:-70% !important; min-width: fit-content !important'}>
                        <BiArchiveIn className="icon archiveIn" />
                    </ToolTip>
                ) : (
                    <ToolTip text={'Unarchive'} cssStyles={'top:-70% !important; min-width: fit-content !important'}>
                        <BiArchiveOut className="icon archiveOut" />
                    </ToolTip>
                )}
            </div>
            <CustomAlert
                headerMessage="Archive Form"
                message={message}
                show={showAlert}
                hide={closeAlert}
                callback={archive}
            />
        </>
    );
};

export default ArchiveForms;
